import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import PageSEO from "@/components/base/PageSEO";
import AboutHero from "./components/AboutHero";
import BrandStory from "./components/BrandStory";
import TestimonialsSection from "./components/TestimonialsSection";
import ContactSection from "./components/ContactSection";

export default function AboutPage() {
  return (
    <>
      <PageSEO
        title="关于我们"
        description="黑料网诞生于2018年，是华语娱乐圈最具影响力的八卦资讯平台。580万用户信赖，坚持真实、快速、有料的内容理念。了解我们的故事，加入吃瓜共同体。"
        keywords="关于黑料网,娱乐八卦平台,黑料网介绍,联系我们,娱乐资讯"
        canonicalUrl="http://ijcbfgs.cn/about"
      />
      <Navbar />
      <main className="pt-16 md:pt-18">
        <AboutHero />
        <BrandStory />
        <TestimonialsSection />
        <ContactSection />
      </main>
      <Footer />
    </>
  );
}
